import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

import { Submit } from '../form'
import AuthTextField from './AuthTextField'
import { InputGroup, Center, AuthToken, Column } from './shared'

const validationSchema = Yup.object({
  user: Yup.object({
    email: Yup.string()
      .required('This field is required')
      .email('Not a valid email'),
  }),
})

const ResendConfirmation = ({ currentUser }) => {
  const formElement = useRef(null)
  const form = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(validationSchema),
    defaultValues: {
      user: { email: currentUser?.email || '' },
    },
  })
  const { handleSubmit } = form

  useEffect(() => {
    if (form.formState.dirtyFields.user?.email) return
    form.reset({ user: { email: currentUser?.email || '' } })
  }, [currentUser?.email, form])

  return (
    <FormProvider {...form}>
      <form
        className="qa-resend-confirmation"
        action="/users/confirmation"
        method="post"
        ref={formElement}
        onSubmit={handleSubmit(() => formElement.current.submit())}
      >
        <AuthToken />

        <div className="container">
          <div className="row">
            <Column className="col-xs-12 col-md-6 col-md-push-3">
              <AuthTextField
                label="Email"
                name="user[email]"
                type="email"
                lessMargin
                readOnly
              />
              <InputGroup>
                <Center>
                  <Submit name="commit" disabled={!currentUser?.email}>
                    Resend Confirmation Instructions
                  </Submit>
                </Center>
              </InputGroup>
            </Column>
          </div>
        </div>
      </form>
    </FormProvider>
  )
}

export default connect(({ auth }) => ({
  currentUser: auth.currentUser,
}))(ResendConfirmation)
